import './core';
require('./core/component');
require('./core/formatter');



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-time-input/src/main.js